/* eslint-disable @typescript-eslint/ban-types */
import { LineItem } from '@pperform/pp-data-mappers';
import APIError from 'exceptions/APIError';
import AppError from 'exceptions/AppError';
import type { ReturnSubmissionFormData } from '../../../interfaces';
import { postReturn } from '../fetchers';

export const submitReturnRequest = async (
  orgId: number,
  slug: string,
  shipmentPk: number,
  returnRequestFormData: ReturnSubmissionFormData,
): Promise<string> => {
  try {
    const {
      attachments = [],
      selectedLineItems,
      comment = '',
    } = returnRequestFormData;

    const returnProofs = attachments.map((item) => ({
      file_name: item.name,
      url: item.url,
    }));

    const lineItems: object[] = Array.from(selectedLineItems?.values()).map(
      (selectedItem) => {
        const { item, reason, quantity, customReason } = selectedItem;

        const { value: returnReason, engDesc } = reason;

        if (engDesc) {
          return LineItem.create({
            ...item,
            returnReason: engDesc,
            quantity,
            additionalInfo: {
              ...item.additionalInfo,
              returnCustomReason: customReason,
              returnReasonEngDesc: returnReason,
            },
          }).toApiData();
        }

        return LineItem.create({
          ...item,
          returnReason,
          quantity,
          additionalInfo: {
            ...item.additionalInfo,
            returnCustomReason: customReason,
          },
        }).toApiData();
      },
    );

    const params = {
      slug,
      shipment_pk: shipmentPk,
      return_proofs: returnProofs,
      comment,
      line_items: lineItems,
    };

    const { data } = await postReturn(orgId, params);
    return data.return_pk;
  } catch (error) {
    if (error instanceof APIError) {
      throw new AppError(error.message);
    }

    throw error;
  }
};
